module.exports = "<div class=\"version\">\r\n    <p class=\"text-secondary\">{{text}}</p>\r\n</div>"